module.exports = __webpack_public_path__ + "img/exam1.7e0e64f9.png";